import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Context } from '../../..';
import UserService from '../../../services/UserService';
import { ModalPopover } from './modal-popover';


const Organization: FC<any> = observer(data => {
    const { specialization, index, setDelId, setDelModal } = data;

    return (
        <tr>
            <th scope="row">{index + 1}</th>
            <td>{specialization['specialization']}</td>
            <td><i className='icon trash' onClick={() => {setDelId(specialization['id']); setDelModal(true)}} /></td>
        </tr>
    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const SpecializationsListModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context)
    const [specializations, setSpecializations] = useState<[]>([]);
    const [fix, setFix] = useState(true);
    const [delId, setDelId] = useState<number>(-1);
    const [delModal, setDelModal] = useState<boolean>(false);

    const getSpecializations = async () => {
        const res = await UserService.getSpecializations('');
        setSpecializations(res.data.results);
    };

    useEffect(() => {
        getSpecializations();
        setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix]);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getSpecs = () => specializations.map((specialization: any, index: number) => {
        return <Organization key={specialization['id']} {...{ specialization, index, setDelId, setDelModal }} />
    })

    const deleteOrg = async () => {
        await UserService.deleteSpecialization(delId);
        setFix(true);
        setDelId(-1);
        setDelModal(false);
    }

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="co-md-1">№</th>
                                <th scope="col-md-3">Специальность</th>
                                <th scope="col-md-2">Управление</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getSpecs()}
                        </tbody>
                    </table>

                </div>
                <ModalPopover
                    toggle={delModal}
                    setToggle={setDelModal}
                    title={store.lang === 'ba' ? 'Һөнәрҙе алып ташлау' : store.lang === 'ru' ? 'Удаление специальности' : 'Deleting a specialization'}
                    modalContent={<Trans>Do you want to delete a specialization?</Trans>}
                    clickedButtonOne={() => deleteOrg()}
                    clickedButtonTwo={() => { setDelModal(false); setDelId(-1); }}
                    ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                    ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
                />
            </form>
        </Modal >
    );
});